import { MutableRefObject } from "react";
import "./DetailsItem.css";
import { Property } from "../../../models/Property";
import { propertyNameFormatter, propertySaleStatus, propertySizeFormatter } from "../../../utilities/propertyUtilities";
import { CalciteIcon} from '@esri/calcite-components-react';

interface iProps {
  property: Property;
  zoomToHandler: Function;
  selectHandler?: Function;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
  onContactUsClick: Function;
  propertyLayer?: MutableRefObject<__esri.FeatureLayer | undefined>;
};


export default function DetailsItem(props: iProps) {
  const { property } = props;
  const propertyName = propertyNameFormatter(property);
  const locationString = property.siteBuildingCity + ', ' + property.siteBuildingState;
  const propertySize = propertySizeFormatter(property, true);
  const saleOrLease = propertySaleStatus(property, true);

  const onItemClick = () => {
    props.selectHandler?.();
  }

  const onContactUsClick = (evt: any) => {
    props.onContactUsClick();
    evt.stopPropagation();
  }

  const onZoomToClick = (evt: any) => {
    props.zoomToHandler();
    evt.stopPropagation();
  }

  const onMouseEnter = (evt: any) => {
    if (props.onMouseEnter) {
      props.onMouseEnter();
    }
  }

  const onMouseLeave = (evt: any) => {
    if (props.onMouseLeave) {
      props.onMouseLeave();
    }
  }

  return (
    <div className={`flex-column property-details-item reduced`}
      onClick={onItemClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <div className="details">
        <div className="flex-row">
          <div className='public-name'>{propertyName}</div>
          {props?.property?.site?.certified === 'Yes' &&
            <CalciteIcon icon='check-shield' title="Certified Property"/>
          }
          
        </div>
        <div className="flex-row info--image__wrapper">
          <div className="thumbnail" style={{ backgroundImage: `url(${props.property.thumbnailImage})` }}>
          </div>
          <div className='flex-column details-info'>
            <div>{locationString}</div>
            <div>{propertySize}</div>
            <div>{saleOrLease}</div>
            <div className="btn-container">
              <button className="link-btn small-font" onClick={onContactUsClick}>Contact Us</button>
              <button className="link-btn small-font" onClick={onZoomToClick}>Zoom To</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};